<div class="bg-light-primary rounded p-y-20 p-x-20 m-b-30 overflow-hidden" *ngIf="navPages && navPages.length >0">
  <div class="row">
    <div class="d-flex align-items-center overflow-hidden m-l-20">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let n of navPages; let last = last">
          <a *ngIf="!last" [routerLink]="n.url">{{ n.title | translate }}</a>
          <label *ngIf="last">{{ n.title | translate }}</label>
        </li>
      </ul>
    </div>
  </div>
</div>
